(function () {
  function animate(fill) {
    var target = fill.dataset.targetWidth;
    var prev = sessionStorage.getItem('dhFsPct') || '0';
    if (prev === target) {
      fill.style.width = target + '%';
      return;
    }
    fill.style.width = prev + '%';
    fill.offsetHeight;
    setTimeout(function () {
      fill.style.width = target + '%';
    }, 20);
    sessionStorage.setItem('dhFsPct', target);
  }

  function scan(root) {
    root.querySelectorAll('.dh-fs__fill[data-target-width]').forEach(animate);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.dh-fs__fill[data-target-width]')) animate(node);
          if (node.querySelectorAll) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
